import React from "react";
import {
  useProduct,
  useTranslation,
} from "@nvs/gatsby-theme-leap-core/src/hooks";
import Section from "@nvs/gatsby-theme-leap-core/src/components/hoc/components/section/section";
import { Link } from "@nvs/gatsby-theme-leap-core/src/components/hoc/components";
import { EventPosition } from "@nvs/gatsby-theme-leap-core/src/services/analytics-interfaces";

const AdherenceService = () => {
  const { t } = useTranslation();
  const { params } = useProduct();
  return (
    <div className="flex flex-col items-center bg-cta-disabled rounded-2xl w-full px-5 py-8 lg:px-12 lg:py-12">
      <Section
        title={t("pages_confirmation_service_adherence_title")}
        description={t("pages_confirmation_service_adherence_description")}
        titleClassName="text-2xl text-left"
        descriptionClassName="text-lg text-left"
      >
        <div className="flex flex-col items-center gap-5">
          <Link
            className="border-none py-3 px-10 text-font-cta text-lg bg-cta hover:bg-cta-hover visited:bg-cta active:bg-cta-hover disabled:bg-cta-disabled disabled:hover:bg-cta-disabled inline-flex justify-center cursor-pointer rounded-full font-semibold whitespace-nowrap mx-auto"
            position={EventPosition.Body}
            aria-label={t("pages_confirmation_service_adherence_button")}
            href={params.website}
            target={"_blank"}
          >
            {t("pages_confirmation_service_adherence_button")}
          </Link>
        </div>
      </Section>
    </div>
  );
};

export default AdherenceService;
